import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Car, Lock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_eurocar-start/artifacts/io6ga27q_eurocars-logo2.png";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch {
      setError("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Euro Cars" className="h-14 mx-auto mb-4" />
          <h1 className="font-outfit font-bold text-2xl text-white">Admin Panel</h1>
          <p className="font-dm-sans text-sm text-slate-400 mt-1">Sign in to manage your fleet</p>
        </div>

        <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm">
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
            {error && (
              <div data-testid="login-error" className="bg-red-50 text-red-600 text-sm font-dm-sans p-3 rounded-lg">
                {error}
              </div>
            )}
            <div>
              <label className="block font-outfit text-xs font-medium text-slate-500 mb-1.5 uppercase tracking-wide">Username</label>
              <Input
                data-testid="admin-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="h-12 bg-slate-50 border-slate-200 rounded-lg"
                required
              />
            </div>
            <div>
              <label className="block font-outfit text-xs font-medium text-slate-500 mb-1.5 uppercase tracking-wide">Password</label>
              <Input
                data-testid="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-12 bg-slate-50 border-slate-200 rounded-lg"
                required
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-btn"
              disabled={loading}
              className="w-full h-12 bg-orange-500 hover:bg-orange-600 text-white font-outfit font-medium rounded-lg shadow-lg"
            >
              <Lock className="w-4 h-4 mr-2" />
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
